/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";

type Option = Readonly<{
  id: string;
}>;

export const DeleteRole = async (option: Option) => {
  const $id = <Variable name="id" scalar={<IdScalar isNullable={false} />} value={option.id} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_ROLE">
      <SelectionSet
        name="deleteRole"
        argument={{
          where: { role_id: $id }
        }}
      >
        <Field name="role_id" alias="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = {
    deleteRole: {
      id: string;
    }[];
  };
  return await clients.role.request<Data>(query, variables);
};
